module.exports = __webpack_public_path__ + "img/used2.22d0473b.webp";